import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

export type NewServicingLoanVariant = 'new-servicing-number' | 'transfer-to-nj';

@Component({
  selector: 'ld-new-servicing-loan-modal',
  imports: [BaseModalComponent, MatIconModule, RouterLink, TranslocoDirective],
  templateUrl: './new-servicing-loan-modal.component.html',
  styleUrl: './new-servicing-loan-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewServicingLoanModalComponent {
  isOpen = input<boolean>(false);
  loanNumber = input.required<string>();
  faqLink = input<string>('/dashboard');
  variant = input<NewServicingLoanVariant>('new-servicing-number');
  continue = output<void>();

  protected onContinue(): void {
    this.continue.emit();
  }
}
